




import Vue from "vue";
import Component from "vue-class-component";

@Component({
  props: {
    graphData: Array
  }
})
export default class BarGraph extends Vue {
  private graphData: any;
  private energyData:any = [];
  private priceData:any = [];
  private months:any = [];

  private chartOptions = {
    chart: {
        zoomType: 'x'
    },
    title: {
        text: ''
    },
    xAxis: [{
        categories: this.months,
        crosshair: true
    }],
    yAxis: [ { // Secondary yAxis
        title: {
            text: 'Income Saved (PKR)',
            style: {
            }
        },
        labels: {
            format: '{value} PKR',
            style: {
            }
        },
        opposite: true
    }, { // Primary yAxis
        labels: {
            format: '{value} kWh',
            style: {
                
            }
        },
        title: {
            text: 'Energy Yield (kWh)',
            style: {
               
            }
        }
    }],
    tooltip: {
        shared: true
    },
    legend: {
        layout: 'vertical',
        align: 'center',
        x: 0,
        verticalAlign: 'top',
        y:0,
    },
    series: [{
        name: 'Energy Yielded',
        type: 'column',
        yAxis: 1,
        color: "#df8c67",
        data: this.energyData,
        tooltip: {
            valueSuffix: ' kWh'
        }

    }, {
        name: 'Income Saved',
        type: 'spline',
        data: this.priceData,
        color: "#754a37",
        tooltip: {
            valueSuffix: ' PKR'
        }
    }]
  };

  mounted() {
      for (let day of this.graphData){
        this.energyData.push(day.energysaved);
        this.priceData.push(day.moneysaved);
        this.months.push(day.date);
      }
  }

  updated() {
  }
}
